import {Select as AntSelect} from 'antd';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {toClass} from 'recompose';
import {IconDown} from '@baidu/ee-icon/svg';
import styles from './index.less';

const getClassNames = ({size, noBorder, className}) => classNames(
    styles[`size-${size}`],
    {[styles.noBorder]: noBorder},
    className
);

const ETUISelect = props => {
    const {size, className, noBorder, ...restProps} = props;

    return (
        <AntSelect
            className={getClassNames({size, noBorder, className})}
            suffixIcon={<IconDown />}
            {...restProps}
        />
    );
};

const ETUISelectClsComponent = toClass(ETUISelect);

// 添加antd select里有的一些属性，比如 Option
Object.assign(ETUISelectClsComponent, AntSelect);

ETUISelectClsComponent.propTypes = {
    className: PropTypes.string,
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    mode: PropTypes.oneOf(['default', 'multiple', 'tags'])
};

ETUISelectClsComponent.defaultProps = {
    className: '',
    size: 'm',
    mode: 'default'
};

export default ETUISelectClsComponent;
